<template>
  <!-- 只保留导航栏部分，移除App结构 -->
  <el-header class="navbar" :class="{ scrolled: isScrolled }">
    <div class="nav-container">
      <!-- Logo品牌 -->
      <div class="nav-brand">
        <router-link to="/" class="brand-link">
          <div class="brand-logo">
            <div class="logo-circle">
              <span class="logo-text">BC</span>
            </div>
          </div>
          <span class="brand-text">
            <span class="brand-main">AlleleBC</span>
            <span class="brand-sub">Biological Information Database</span>
          </span>
        </router-link>
      </div>

      <!-- PC端导航菜单 -->
      <div class="nav-menu" v-show="!isMobile">
        <router-link
          v-for="item in navItems"
          :key="item.path"
          :to="item.path"
          class="nav-item"
        >
          <span class="nav-text">{{ item.name }}</span>
        </router-link>
      </div>

      <!-- 操作区域 -->
      <div class="nav-actions">
        <!-- 搜索输入框 - 修改为长条形直接输入 -->
        <div v-if="!isMobile" class="search-wrapper">
          <el-input
            placeholder="Search genes, variants, diseases..."
            v-model="searchQuery"
            @keyup.enter="handleSearch"
            class="search-input"
            size="default"
          >
            <template #prefix>
              <el-icon><Search /></el-icon>
            </template>
            <template #suffix>
              <el-button
                v-if="searchQuery"
                class="search-clear"
                @click="searchQuery = ''"
                :bg="false"
                text
                size="small"
              >
                ×
              </el-button>
            </template>
          </el-input>
          <el-button
            class="search-submit-btn"
            @click="handleSearch"
            type="primary"
            size="default"
          >
            Search
          </el-button>
        </div>

        <!-- 移动端菜单按钮 -->
        <el-button
          class="menu-toggle"
          @click="menuOpen = !menuOpen"
          :class="{ active: menuOpen }"
          v-show="isMobile"
          :icon="menuOpen ? 'Close' : 'Menu'"
          :bg="false"
          text
        />
      </div>
    </div>

    <!-- 移动端菜单 -->
    <div v-if="isMobile && menuOpen" class="mobile-menu">
      <!-- 移动端搜索 -->
      <div class="mobile-search">
        <el-input
          placeholder="Search genes, variants, diseases..."
          v-model="searchQuery"
          @keyup.enter="handleSearch"
          size="default"
        >
          <template #prefix>
            <el-icon><Search /></el-icon>
          </template>
        </el-input>
        <el-button
          class="mobile-search-btn"
          @click="handleSearch"
          type="primary"
          size="default"
        >
          Search
        </el-button>
      </div>

      <!-- 移动端菜单项 -->
      <div class="mobile-nav-items">
        <router-link
          v-for="item in navItems"
          :key="item.path"
          :to="item.path"
          class="mobile-nav-item"
          @click="menuOpen = false"
        >
          <span class="nav-text">{{ item.name }}</span>
        </router-link>
      </div>
    </div>
  </el-header>
</template>

<script>
import { Search, Menu, Close } from '@element-plus/icons-vue'

export default {
  name: 'NavBar',
  components: {
    Search,
    Menu,
    Close
  },
  data() {
    return {
      menuOpen: false,
      searchQuery: '',
      isScrolled: false,
      isMobile: false,
      navItems: [
        { name: 'Home', path: '/' },
        { name: 'Data Search', path: '/search' },
        { name: 'Tools', path: '/tools' },
        { name: 'Data Download', path: '/download' },
        { name: 'Submit Data', path: '/submit' },
        { name: 'About Us', path: '/about' },
        { name: 'Help', path: '/help' }
      ]
    }
  },
  methods: {
    handleSearch() {
      if (this.searchQuery.trim()) {
        // TODO: 后期会改成具体搜索逻辑
        this.$router.push({
          path: '/search',
          query: {q: this.searchQuery}
        })
        this.menuOpen = false
      }
    },
    handleScroll() {
      this.isScrolled = window.scrollY > 50
    },
    checkMobile() {
      this.isMobile = window.innerWidth <= 768
      if (!this.isMobile) {
        this.menuOpen = false
      }
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll)
    window.addEventListener('resize', this.checkMobile)
    this.checkMobile()

    // 点击外部关闭菜单
    document.addEventListener('click', (e) => {
      if (!e.target.closest('.navbar')) {
        this.menuOpen = false
      }
    })
  },
  unmounted() {
    window.removeEventListener('scroll', this.handleScroll)
    window.removeEventListener('resize', this.checkMobile)
  }
}
</script>

<style scoped>
.navbar {
  background: linear-gradient(135deg, #2c3e50 0%, #3498db 100%);
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1000;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  height: 70px !important; /* 固定导航栏高度 */
  padding: 0 !important;
}

.navbar.scrolled {
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.nav-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 70px; /* 与导航栏高度一致 */
  position: relative;
}

/* Logo样式 */
.nav-brand {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.brand-link {
  display: flex;
  align-items: center;
  text-decoration: none;
  gap: 12px;
}

.brand-link:hover {
  opacity: 0.9;
}

.brand-logo {
  width: 45px;
  height: 45px;
  position: relative;
}

.logo-circle {
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.15);
  border: 2px solid rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo-text {
  color: white;
  font-weight: bold;
  font-size: 16px;
}

.brand-text {
  display: flex;
  flex-direction: column;
}

.brand-main {
  font-size: 26px;
  font-weight: bold;
  color: white;
  line-height: 1.2;
}

.brand-sub {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.8);
  margin-top: 2px;
}

/* 导航菜单 */
.nav-menu {
  display: flex;
  gap: 0;
  align-items: stretch;
  height: 100%;
  flex-shrink: 0;
}

.nav-item {
  position: relative;
  display: flex;
  align-items: center;
  padding: 0 20px;
  text-decoration: none;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 500;
  margin: 0;
  transition: all 0.3s ease;
  height: 100%;
}

.nav-item:hover {
  background: rgba(255, 255, 255, 0.15);
  color: white;
}

.nav-item.router-link-active {
  background: rgba(255, 255, 255, 0.2);
  color: white;
}

.nav-item.router-link-active::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: white;
}

.nav-text {
  font-size: 15px;
}

/* 操作按钮区域 */
.nav-actions {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

/* 搜索区域包装器 */
.search-wrapper {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* 搜索输入框样式 - 长条形 */
:deep(.search-input) {
  width: 320px; /* 加宽搜索框 */
}

:deep(.search-input .el-input__wrapper) {
  background: rgba(255, 255, 255, 0.1) !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  border-radius: 25px !important; /* 圆角长条形 */
  box-shadow: none !important;
  transition: all 0.3s ease !important;
}

:deep(.search-input .el-input__inner) {
  color: white !important;
  padding-left: 15px !important;
  padding-right: 40px !important; /* 为清除按钮留空间 */
}

:deep(.search-input .el-input__inner::placeholder) {
  color: rgba(255, 255, 255, 0.6) !important;
}

:deep(.search-input .el-input__prefix) {
  color: rgba(255, 255, 255, 0.7) !important;
  left: 12px !important;
}

:deep(.search-input .el-input__suffix) {
  right: 8px !important;
}

:deep(.search-input.is-focus .el-input__wrapper) {
  background: rgba(255, 255, 255, 0.15) !important;
  border-color: rgba(255, 255, 255, 0.4) !important;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.1) !important;
}

/* 清除按钮样式 */
.search-clear {
  background: transparent !important;
  border: none !important;
  color: rgba(255, 255, 255, 0.6) !important;
  font-size: 18px !important;
  width: 20px !important;
  height: 20px !important;
  padding: 0 !important;
  border-radius: 50% !important;
  transition: all 0.3s ease !important;
}

.search-clear:hover {
  background: rgba(255, 255, 255, 0.2) !important;
  color: white !important;
}

/* 搜索提交按钮 */
.search-submit-btn {
  background: rgba(255, 255, 255, 0.2) !important;
  border: 1px solid rgba(255, 255, 255, 0.3) !important;
  color: white !important;
  border-radius: 20px !important;
  padding: 0 20px !important;
  font-weight: 500 !important;
  transition: all 0.3s ease !important;
}

.search-submit-btn:hover {
  background: rgba(255, 255, 255, 0.3) !important;
  border-color: rgba(255, 255, 255, 0.5) !important;
  transform: translateY(-1px) !important;
}

/* 移动端菜单按钮 */
.menu-toggle {
  background: transparent !important;
  border: none !important;
  color: white !important;
  width: 45px !important;
  height: 45px !important;
  border-radius: 6px !important;
  transition: all 0.3s ease !important;
}

.menu-toggle:hover {
  background: rgba(255, 255, 255, 0.15) !important;
}

/* 移动端菜单 */
.mobile-menu {
  background: rgba(44, 62, 80, 0.98);
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding: 20px;
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  animation: slideDown 0.3s ease;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.mobile-search {
  margin-bottom: 20px;
  display: flex;
  gap: 10px;
}

:deep(.mobile-search .el-input) {
  flex: 1;
}

:deep(.mobile-search .el-input__wrapper) {
  background: rgba(255, 255, 255, 0.1) !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  border-radius: 6px !important;
}

:deep(.mobile-search .el-input__inner) {
  color: white !important;
}

:deep(.mobile-search .el-input__inner::placeholder) {
  color: rgba(255, 255, 255, 0.6) !important;
}

:deep(.mobile-search .el-icon) {
  color: rgba(255, 255, 255, 0.7) !important;
}

.mobile-search-btn {
  flex-shrink: 0;
}

.mobile-nav-items {
  display: flex;
  flex-direction: column;
}

.mobile-nav-item {
  display: flex;
  align-items: center;
  padding: 12px 0;
  color: rgba(255, 255, 255, 0.9);
  text-decoration: none;
  font-size: 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  transition: color 0.3s ease;
}

.mobile-nav-item:hover {
  color: white;
}

.mobile-nav-item:last-child {
  border-bottom: none;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  :deep(.search-input) {
    width: 280px;
  }
}

@media (max-width: 992px) {
  :deep(.search-input) {
    width: 240px;
  }

  .brand-sub {
    display: none;
  }
}

@media (max-width: 768px) {
  .navbar {
    height: 60px !important;
  }

  .nav-container {
    height: 60px;
  }

  .brand-logo {
    width: 35px;
    height: 35px;
  }

  .logo-text {
    font-size: 14px;
  }

  .brand-main {
    font-size: 22px;
  }
}

@media (max-width: 480px) {
  .nav-container {
    padding: 0 15px;
  }

  .brand-main {
    font-size: 20px;
  }
}
</style>